// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__fJBvA","backdrop":"Dialog_backdrop__CVflj","content":"Dialog_content__SvUmL","close":"Dialog_close__EIoUb","dialog--open":"Dialog_dialog--open__Q6vBM"};